module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("奖项设置")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("中国建筑新人赛Top3")]), _vm._v(" "), _c('div', [_vm._v("获得证书、纪念品及10000元奖金")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("中国建筑新人赛Top16")]), _vm._v(" "), _c('div', [_vm._v("获得证书、纪念品及2000元奖金")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("中国建筑新人赛Top100")]), _vm._v(" "), _c('div', [_vm._v("获得证书、纪念品")]), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.centerDialogVisible,
      "width": "90%",
      "center": ""
    }
  }, [_c('span', [_vm._v("本网站不支持移动端浏览，为了更好的用户体验，请在电脑上登录网站进行大赛报名")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/banner2025.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section firsts"
  }, [_c('p', {}, [_vm._v("\n        一年一度的东南·中国建筑新人赛盛大归来！2026年，我们将再聚南京，在这里与来自不同学校的优秀选手肩并肩、与高水平的指导教师团队面对面；2026年，我们与去年保持一致，突破传统、追求独立，东南·中国建筑新人赛继续专注于中国建筑学的低年级教育、展现中国建筑新生的优异风采，着力于为低年级学生提供更好的竞赛平台与更多的交流机会。\n\t")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("新人赛是什么")]), _vm._v(" "), _c('p', [_vm._v("\n            新人赛为建筑学学生作业展示与竞赛、各国建筑教育者提供了积极的交流平台。 \n\n        ")]), _vm._v(" "), _c('p', {}, [_vm._v("\n            东南大学建筑学院突出“自主、开放、交流”的特点，面向全国各高校的本科一年级至三年级建筑专业学生征稿，旨在为年轻鲜活的低年级设计者提供竞赛平台，并鼓励他们展现创造性与合理性并存的设计思维，体现中国建筑学科的新生力量。 \n\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/home-group-photo-2025.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("新人赛新在哪儿")]), _vm._v(" "), _c('p', [_vm._v("\n            中国建筑新人赛的定位是搭建全新的、颠覆传统建筑竞赛形式的竞赛平台，本质上是一场开放自由的建筑秀场和交流会。 \n\t    ")]), _vm._v(" "), _c('p', [_vm._v("\n            新人赛通过微信平台、作品网络提交、志愿者线下联系等多种途径让赛事信息最快传达；赛事经过海选评出的100强选手将被邀请至东南大学建筑学院，与来自五湖四海的建筑学学子彼此学习，与诸多建筑界精英面对面讨论方案、交流思想。同时，新人赛通过开放评选、学生参与、自发交流的三方面特点来消除传统竞赛作品提交、评选、发布等环节脱离，选手间、选手与主办方脱节的弊端。 \n\t    ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {}, [_vm._v("\n            让我们期待一同享受这属于建筑学界的饕餮盛宴！\n\t    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("组织机构")]), _vm._v(" "), _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name linetitle"
  }, [_vm._v("主办方")])]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("东南大学建筑学院、东南大学建筑设计研究院有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name linetitle"
  }, [_vm._v("协办方")])]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("《建筑学报》")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("参赛资格")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("参赛者")]), _vm._v(" "), _c('div', [_vm._v("\n            我们欢迎中国（含港澳台）各高校"), _c('i', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("建筑学院（建筑系）三年级及以下")]), _vm._v("在读本科生投稿"), _c('br'), _c('br')]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("提交作品")]), _vm._v(" "), _c('div', [_vm._v("\n            前述参赛者在"), _c('i', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("本科阶段一年级至-三年级")]), _vm._v("学习期间的建筑设计作业"), _c('br'), _c('br')]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("竞赛主题")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("\n            不设置竞赛主题，以各校教学环节的 "), _c('i', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("设计任务书")]), _vm._v("为依据\n        ")]), _vm._v(" "), _c('div'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("注意事项：")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("\n1. 以上条件必须同时满足"), _c('br'), _vm._v("\n2. 每个参赛者只能提交一份参赛作品"), _c('br'), _vm._v("\n3. 规划类或风景园林类专业学生亦可参赛，但投稿作品必须是建筑设计作品"), _c('br'), _vm._v("\n4. 提交作品应基于设计课作业成果，可进行一定的修改和完善，需提交设计科任务书且必须为本教学年度（2025-2026学年）作品（例：三年级同学只能提交第三学年作品，不得提交第一或第二学年作品）"), _c('br'), _vm._v("\n5. 不接受已经在其他竞赛中获奖的作品"), _c('br'), _vm._v("\n6. 不接受任何形式的合作作品（合作作品仅一人署名也不接受）"), _c('br'), _vm._v("\n7. 作品需以实体模型为重要表现载体，不接受无实体模型作品，入围100强的作品需按要求修改并提交至少一张模型照片"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("赛程")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("即日起-2026.8.5")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("报名并提交电子图纸到本网站。请按照网页提示内容填写参赛者个人信息，并依步骤上传图纸\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle "
  }, [_vm._v("图纸内容")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("封面1张，任务书1页，图纸4页，视频1个（如需要）\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("注意事项")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("封面尺寸统一为800*600，图纸、任务书大小不超过2MB，分辨率在4000*4000以内，支持jpeg格式和png格式，除了登录信息以外，图纸上不得出现任何与参赛学校或个人相关的信息，否则投稿作品作废。图纸中不得使用繁体字。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("2026.8.5-2026.8.11")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("海选评选")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("由各高校负责本科建筑设计教学的教师组成评委团队进行线上匿名打分，5分制，每个作品得分为三名评委的分数的平均分。并以此得分决定进入100强的参赛作品。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("网站公示")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("海选评选获奖结果经确认后将在本网站公布，同时公开100强作品供阅览。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("2026.8.23-2026.9.17")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("进入前100名的参赛者对图纸进行修改与第二轮提交。（提交通道将于8.23开启）\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("第二轮提交内容")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("每位参赛者提交2-5张图纸（A2横版）及1-2张实体模型照片（A2横版）\n（具体要求将后续通知）")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("2026.9.19上午")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("100进16强决赛")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("评选方式：评委线下投票\n届时100强选手将来到现场参与布展，9月19日上午评委将在现场为图纸打分\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("2026.9.19下午")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("总决赛")]), _vm._v(" "), _c('div', {
    staticClass: "lastp"
  }, [_vm._v("评选方式：线下答辩\n9月19日下午16强选手现场答辩，现场产生前三获得者\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/home-2025-logo-banner.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a942b9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 624
// module chunks = 1